import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { tokenForUrl, UtilApiAuthService } from './util-api-auth.service';

export const utilApiAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(UtilApiAuthService);
  const token = tokenForUrl(auth.credentials(), req.url, document.baseURI);
  if (!token) return next(req);
  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 401) auth.unauthorized.set(true);
      return throwError(() => error);
    }),
  );
};
